import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { RedirectGuard } from './core/guards/redirect.guard';
import { SessionGuard } from './core/guards/session.guard';
import { CustomEditorComponent } from './shared/components/custom-editor/custom-editor.component';
import { SeniorLawyerAuthGuard } from './guards/senior-lawyer-auth.guard';
import { ClerkAuthGuard } from './guards/clerk-auth.guard';
import { AdminAuthGuard } from './guards/admin-auth.guard';




const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'logout', redirectTo: 'auth/logout', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(r => r.AuthModule)
  },
  {
    path:'custom-editor',
    component:CustomEditorComponent
  },


  {
    path: 'admin',
    canActivate:[AdminAuthGuard],
    loadChildren: () => import('./features/main/admin/admin.module').then(r => r.AdminModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./features/main/user/user.module').then(r => r.UserModule)
  },
  {
    path:"senior-lawyer",
    canActivate:[SeniorLawyerAuthGuard],
    loadChildren:()=> import('./features/main/senior-lawyer/senior-lawyer.module').then(r=>r.SeniorLawyerModule)
  },
  {
    path:"clerk",
    canActivate:[ClerkAuthGuard],
    loadChildren:()=> import('./features/main/clerk/clerk.module').then(r=>r.ClerkModule)
  },
  
  
  
 
  { path: '**', component: PageNotFoundComponent },  // Wildcard route for a 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      // preloadingStrategy: PreloadAllModules,
      // enableTracing: true
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
